//data taken from https://www.listchallenges.com/50-books-to-read-before-you-die
const books = {
  book1: {
    name: "The Lord of the Rings Trilogy",
    image: "/images/tolkien.jpg",
    desc:
      "The Lord of the Rings, by J.R.R. Tolkien, tells the story of the War of the Ring in the fictional world of Middle-earth. ... Now, the free peoples of Middle-earth, such as Men, Elves, Dwarves, and Hobbits, must overcome the dark power of Sauron by destroying the Ring.",
    price: 1724,
    available: true,
    author: "J. R. R. Tolkien",
    category: "fantasy",
    visible: true,
    modalVisible: false
  },

  book2: {
    name: "1984",
    image: "/images/1984.jpg",
    desc:
      "In George Orwell's 1984, Winston Smith wrestles with oppression in Oceania, a place where the Party scrutinizes human actions with ever-watchful Big Brother. Defying a ban on individuality, Winston dares to express his thoughts in a diary and pursues a relationship with Julia.",
    price: 684,
    available: true,
    author: "George Orwell",
    category: "fiction",
    visible: true,
    modalVisible: false
  },

  book3: {
    name: "Pride and Prejudice",
    image: "/images/pride.jpg",
    desc:
      "Pride and Prejudice is a humorous story of love and life among English gentility during the Georgian era. Mr Bennet is an English gentleman living in Hartfordshire with his overbearing wife. ... Love is soon in the air for one of the Bennet sisters, while another may have jumped to a hasty prejudgment.",
    price: 1129,
    available: false,
    author: "Elizabeth Bennet",
    category: "novel",
    visible: true,
    modalVisible: false
  },

  book4: {
    name: "The Grapes of Wrath",
    image: "/images/grapes.jpg",
    desc:
      "John Steinbeck's The Grapes of Wrath, Tom Joad and his family are forced from their farm in the Depression-era Oklahoma Dust Bowl and set out for California along with thousands of others in search of jobs, land, and hope for a brighter future.",
    price: 1234,
    available: true,
    author: "John Steinbeck",
    category: "novel",
    visible: true,
    modalVisible: false
  },

  book5: {
    name: "To Kill a Mockingbird",
    image: "/images/mockinbid.jpg",
    desc:
      "The story is told by the little six-year-old girl Jean Louise Finch nicknamed Scout. She is a rebellious girl who has tomboy tendencies. The storyline is based in Maycomb, a small town in Alabama in the 1930s where Scout lives with her elder brother Jem, and her father, Atticus, who is widowed.",
    price: 1453,
    available: true,
    author: "Harper Lee",
    category: "novel",
    visible: true,
    modalVisible: false
  },

  book6: {
    name: "Jane Eyre",
    image: "/images/jane.jpg",
    desc:
      "Ten-year-old orphan Jane Eyre lives unhappily with her wealthy, cruel cousins and aunt at Gateshead. Her only salvation from her daily humiliations, such as being locked up in a \"red-room\" (where she thinks she sees her beloved uncle's ghost), is the kindly servant, Bessie.",
    price: 583,
    available: true,
    author: "Charlotte Bronte",
    category: "novel",
    visible: true,
    modalVisible: false
  },

  book7: {
    name: "Wuthering Heights",
    image: "/images/heights.jpg",
    desc:
      "The story revolves around the tempestuous romance between Heathcliff, an orphan who is taken home to Wuthering Heights on impulse, and Catherine Earnshaw, a strong-willed girl whose mother died delivering her and who becomes Heathcliff's close companion. The setting is central to the novel.",
    price: 1528,
    available: true,
    author: "Emily Bronte",
    category: "novel",
    visible: true,
    modalVisible: false
  },

  book8: {
    name: "A Passage to India",
    image: "/images/india.jpg",
    desc:
      "E.M. Forster's A Passage to India concerns the relations between the English and the native population of India during the colonial period in which Britain ruled India. The novel takes place primarily in Chandrapore, a city along the Ganges River notable only for the nearby Marabar caves.",
    price: 1835,
    available: true,
    author: "E.M. Forster",
    category: "novel",
    visible: true,
    modalVisible: false
  },

  book9: {
    name: "Alice's Adventures in Wonderland",
    image: "/images/alice.jpg",
    desc:
      "Alice is sitting with her sister outdoors when she spies a White Rabbit with a pocket watch. Fascinated by the sight, she follows the rabbit down the hole. She falls for a long time, and finds herself in a long hallway full of doors.",
    price: 985,
    available: true,
    author: "E.M. Forster",
    category: "fantasy",
    visible: true,
    modalVisible: false
  }
};

export default books;
